export default __webpack_public_path__ + "98ad967b2b7479f2fb8d33a023e7170d.svg";